import { Box, Grid, Modal, TextField } from "@mui/material";
import { searchedElementDisplay } from "./receiptFunctions";
import SearchIcon from "@mui/icons-material/Search";
import UserCard from "./userCard";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { getCounterSalesCustomers } from "./paymentReceiptApi";
import { ModalHeader } from "../../common/modalHeader";

const PaymentReceiptSearchModal = ({
  searchModal,
  setSearchModal,
  unPaidBill,
  getUnpaid,
  setBillData,
  search,
  setSearch,
  setUSerObject,
  setUnPaidBill,
  setUnPaidBillData,
  setPagination,
  billData,
  callSearchApi,
  setSelectedUser,
  // setSelectedUser,
  // userDetail,
}) => {
  const [searchCurrentModal, setSearchCurrentModal] = useState("");
  const getCounterSalesCusomter = async (param) => {
    await getCounterSalesCustomers(param).then((res) => {
      const sortedData = res?.data?.data?.sort((a, b) =>
        a?.name?.toLowerCase().localeCompare(b?.name?.toLowerCase())
      );
      console.log("countersales res data   ", res?.data?.data, " ", {
        page: res.data.pageNumber,
        total: res.data.totalPages,
      });
      setPagination({
        page: res.data.pageNumber,
        total: res.data.totalPages,
      });
      setUnPaidBill(sortedData);
    });
  };

  useEffect(() => {
    console.log("dddd");
    if (searchModal === true) {
      getCounterSalesCusomter({
        filter: "",
        search: "",
        page: 1,
        pageSize: 1000,
      });
      //   setBillData({ ...billData, mybusinessId: userDetail?.myBusinessId });
    } else {
      console.log("close");
      //   setBillData(data);
      setUnPaidBillData();

      setSearchCurrentModal("");
    }
  }, [searchModal]);
  return (
    <Modal
      open={searchModal}
      sx={{ zIndex: 999999 }} 
      onClose={() => {
        setSearchModal(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "65%", md: "50%", lg: "40%" },

          overflowY: "auto",
          // height: "65vh",
          position: "absolute",
          borderRadius: "10px",
          left: { xs: "2%", sm: "25%", md: "25%", lg: "35%", },

          top: "20%",
        }}
      >
        <ModalHeader
          title="Customer List"
          onClose={() => {
            setSearchModal(false);
          }}
        />

        <Grid item xs={12} sx={{ p: "3px" }}>
          <Box sx={{ textAlign: "center", px: 2, pt:1, pb:0 }}>
            <TextField
              sx={{
                width: "100%",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
              size="small"
              label="Customer Name"
              value={searchCurrentModal}
              onChange={(e) => {
                // getPaymentRec(
                //   {
                //       "page": 1,
                //       "pageSize": 10,
                //       "filter": e.target.value,//"filter": null,
                //       "search": "",
                //       "date": null

                //   },
                //   getPaymentReceipt,
                //   setNumberOfRecords,
                //   setTotals,
                //   totals,
                //   setReceipts
                // );
                setSearchCurrentModal(e.target.value);
              }}
              InputLabelProps={{
                sx: {
                  color: "#545454",
                  fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  paddingX: "7px",
                },
              }}
              InputProps={{
                endAdornment: (
                  <SearchIcon
                    sx={{
                      color: (theme) => theme.palette.primary.main,
                    }}
                  />
                ),
              }}
            />
          </Box>

          <Box sx={{ height: "55vh", overflowY: "auto" }}>
            <Grid container spacing={1} sx={{ p: 1 }}>
              {unPaidBill.map((item, index) => {
                if (
                  searchedElementDisplay(
                    { ...item, mobile: item?.customerMobile || "" },
                    searchCurrentModal
                  )
                ) {
                  return null;
                }
                return (
                  <Grid item xs={12} key={item?.id || index}>
                    <UserCard
                      data={item}
                      callBack={() => {
                        setSelectedUser({
                          name: item?.name,
                          mobile: item?.customerMobile,
                        });
                        callSearchApi(item?.mobile);
                        setSearch(item?.name);
                        setSearchModal(false);
                      }}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        </Grid>
      </Box>
    </Modal>
  );
};

export default PaymentReceiptSearchModal;
